<base-site-layout
    [heading]="'Einstellungen' | translate"
    headerIcon="fas fa-cog"
    [isDialog]="true"
    (dialogCloseClicked)="cancel()"
>
    <div class="purchasing-group-settings__content">
        @if (loading()) {
            <div class="d-flex justify-content-center my-3">
                <iim-spinner size="medium"></iim-spinner>
            </div>
        } @else if (loadError()) {
            <div class="alert alert-danger mb-0">
                {{ 'Einstellungen konnten nicht geladen werden.' | translate }}
            </div>
        } @else {
            <form [formGroup]="form">
                <div class="purchasing-group-settings__setting-row">
                    <div class="pe-3">
                        <div class="fw-semibold">{{ 'Im Bestellprozess anzeigen' | translate }}</div>
                        <div class="text-muted mt-1">
                            {{
                                'Wenn deaktiviert, wird die Einkäufergruppe in keiner Warenkorbposition angezeigt und nicht auf Pflichtangabe geprüft.'
                                    | translate
                            }}
                        </div>
                    </div>

                    <mat-slide-toggle
                        color="primary"
                        formControlName="showDuringOrderingProcess"
                        (change)="onShowDuringOrderingProcessChange()"
                    ></mat-slide-toggle>
                </div>

                <hr class="my-2" />

                <div
                    class="purchasing-group-settings__setting-row"
                    [class.opacity-50]="!form.controls.showDuringOrderingProcess.value"
                >
                    <div class="pe-3">
                        <div class="fw-semibold">{{ 'Pflichtfeld' | translate }}</div>
                        <div class="text-muted mt-1">
                            {{
                                'Wenn aktiviert, werden zukünftige Bestellpositionen ohne ermittelbare Einkäufergruppe bei der Erstellung blockiert.'
                                    | translate
                            }}
                        </div>
                    </div>

                    <mat-slide-toggle color="primary" formControlName="required"></mat-slide-toggle>
                </div>

                <hr class="my-2" />

                <div class="mb-1 mt-1">
                    <div class="fw-semibold mb-1">{{ 'Standard-Einkäufergruppe' | translate }}</div>
                    <div class="text-muted mb-2">
                        {{
                            'Fallback für Freigabe-Workflows, wenn einem Beleg keine Einkäufergruppe zugeordnet ist. Nur aktive Einkäufergruppen können als Standard gesetzt werden.'
                                | translate
                        }}
                    </div>
                    <select class="form-select" formControlName="defaultPurchasingGroupId">
                        <option [ngValue]="null">{{ 'Kein Standard' | translate }}</option>
                        @for (group of purchasingGroups(); track group.id) {
                            <option [ngValue]="group.id" [disabled]="!group.active">
                                {{ group.code }} – {{ group.name }}{{ !group.active ? (' (' + ('inaktiv' | translate) + ')') : '' }}
                            </option>
                        }
                    </select>
                </div>
            </form>

            <hr class="my-2" />

            <div class="purchasing-group-settings__rules">
                <div class="fw-semibold mb-1">
                    <em class="fas fa-info-circle text-primary pe-1"></em>
                    {{ 'Regelwerk zur Ermittlung auf Kopfebene' | translate }}
                </div>
                <div class="text-muted">
                    {{
                        'Für die Ermittlung der Einkäufergruppe auf Kopfebene gilt ein dreistufiges Regelwerk:'
                            | translate
                    }}
                </div>
                <ol class="text-muted mt-2 mb-2 ps-4">
                    <li>
                        <span class="fw-semibold">{{ 'Einheitlichkeit' | translate }}</span>
                        {{
                            '– sind alle Positionen derselben Einkäufergruppe zugeordnet, wird diese übernommen.'
                                | translate
                        }}
                    </li>
                    <li>
                        <span class="fw-semibold">{{ 'Mehrheit' | translate }}</span>
                        {{
                            '– ansonsten gewinnt die Einkäufergruppe mit den meisten Positionen.'
                                | translate
                        }}
                    </li>
                    <li>
                        <span class="fw-semibold">{{ 'First Match' | translate }}</span>
                        {{ '– bei Gleichstand wird die Einkäufergruppe der ersten Position übernommen.' | translate }}
                    </li>
                </ol>
                <div class="text-muted small">
                    {{ 'Dieses Regelwerk ist fest aktiv und nicht einzeln konfigurierbar.' | translate }}
                </div>
            </div>
        }

        <div class="d-flex justify-content-end gap-2 mt-4">
            <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
                <em class="fas fa-times pe-1"></em>
                {{ (loadError() ? 'Schließen' : 'Abbrechen') | translate }}
            </button>
            @if (!loadError()) {
                <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saveDisabled()">
                    @if (saving()) {
                        <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
                    }
                    <em class="fas fa-check pe-1"></em>
                    {{ 'Speichern' | translate }}
                </button>
            }
        </div>
    </div>
</base-site-layout>
